import { useTableGeometryCtx } from './useTableGeometry';
import './gameroom.css';

// Small floating badge above a seat showing the player's most recent action this stage
// (Fold / Check / Call / Bet / Raise). Driven by the server's per-seat `lastAction`, which the
// backend nulls at every stage boundary — so the bubble auto-clears when the stage advances
// (including not lingering past a fold). Colors per the design: black fold, grey check,
// blue call, orange bet/raise. "bet" is an opening wager (no prior bet this street); "raise"
// increases an existing one.
const LABELS = { fold: 'Fold', check: 'Check', call: 'Call', bet: 'Bet', raise: 'Raise' };

const ActionBubble = ({ seat, action }) => {
    const { seatActionBubbleStyle } = useTableGeometryCtx();
    const label = LABELS[action];
    if (!label) return null;
    const positionStyle = seatActionBubbleStyle(seat);
    if (!positionStyle) return null;
    return (
        <div className={`action-bubble action-bubble-${action}`} style={positionStyle}>
            {label}
        </div>
    );
};

export default ActionBubble;
